import React from 'react'
import PropTypes from 'prop-types'
import Skeleton from 'react-loading-skeleton'

import AdCardMetrics from '../../../../../features/components/AdCardListItem/AdCardMetrics'
import AdCardListItem from '../../../../../features/components/AdCardListItem'
import SkeletonAdPreview from '../../../../../forms/Tiktok/AdForms/AdTikTokEdit/AdTikTokPreview/Skeleton'
import SkeletonAdCardDetails from '../../../../../features/components/AdCardListItem/AdCardDetails/Skeleton'
import AdCardMetricSkeleton from '../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric/AdCardMetricSkeleton'
import SkeletonInternalAdActionButtons from '../../../../AdApprovals/AdsSection/InternalAdActionButtons/Skeleton'

import useStyles from './styles'

function SkeletonTikTokAdPreviewCardItem({
  showStatusChip = true,
  showDetails = true,
  showMetrics = true,
  showInternalAdActionButtons = false,
  showConversionsMetric,
  showAdditionalMetrics
}) {
  const classes = useStyles()

  return (
    <AdCardListItem>
      {showStatusChip && (
        <div className={classes.cardHeader}>
          {showStatusChip && (
            <div style={{ width: 62 }}>
              <Skeleton />
            </div>
          )}
        </div>
      )}
      <div className={classes.adPreviewContainer}>
        <SkeletonAdPreview className={classes.adPreview} />
      </div>
      <div className={classes.previewContainer} />
      {showDetails && <SkeletonAdCardDetails showSubTitle={false} />}

      {showMetrics && (
        <AdCardMetrics>
          <AdCardMetricSkeleton />
          <AdCardMetricSkeleton />
          <AdCardMetricSkeleton />
          {showConversionsMetric && <AdCardMetricSkeleton />}
          {showAdditionalMetrics && <AdCardMetricSkeleton />}
        </AdCardMetrics>
      )}
      {showInternalAdActionButtons && <SkeletonInternalAdActionButtons />}
    </AdCardListItem>
  )
}

SkeletonTikTokAdPreviewCardItem.propTypes = {
  showStatusChip: PropTypes.bool,
  showDetails: PropTypes.bool,
  showMetrics: PropTypes.bool,
  showInternalAdActionButtons: PropTypes.bool,
  showConversionsMetric: PropTypes.bool,
  showAdditionalMetrics: PropTypes.bool
}

export default SkeletonTikTokAdPreviewCardItem
